<template>
  <div v-if="visible" class="consent-banner" role="dialog" aria-labelledby="consent-title">
    <h2 id="consent-title">{{ $t('consent.title') }}</h2>
    <p>
      {{ $t('consent.text') }}
      <router-link :to="privacyPath">{{ $t('consent.privacy') }}</router-link>
    </p>
    <!-- Declining is exactly as easy as accepting (same size, same step) -->
    <div class="consent-actions">
      <button class="consent-btn" @click="choose('denied')">{{ $t('consent.decline') }}</button>
      <button class="consent-btn" @click="choose('granted')">{{ $t('consent.accept') }}</button>
    </div>
  </div>
</template>

<script>
import { consentState, setConsent, isPatientRoute } from '../consent';
import { splitLocalePath } from '../i18n/locales';

export default {
  computed: {
    // First-time question is not shown over a live session screen; the
    // therapist normally answers it on the homepage before starting.
    onSessionScreen() {
      const path = this.$route.path;
      return isPatientRoute(path) || splitLocalePath(path).path === '/controller';
    },
    privacyPath() {
      return this.$localePath('/privacy');
    },
    visible() {
      if (consentState.settingsOpen) return true;
      return consentState.choice === null && !this.onSessionScreen;
    }
  },
  methods: {
    choose(choice) {
      setConsent(choice, this.$route.path);
    }
  }
};
</script>

<style scoped>
.consent-banner {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 90;
  max-width: 520px;
  margin: 0 auto;
  background: var(--c-bg-dark, #1A2F2C);
  color: var(--c-text-inv, #F0EFEA);
  border-radius: 14px;
  padding: 1.25rem 1.35rem;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.35);
}
.consent-banner h2 {
  font-family: var(--ff-body);
  font-size: 0.98rem;
  font-weight: 600;
  margin-bottom: 0.45rem;
}
.consent-banner p {
  font-size: 0.86rem;
  line-height: 1.55;
  opacity: 0.85;
  margin-bottom: 1rem;
}
.consent-banner a {
  color: var(--c-accent-light, #D4AB6A);
  font-weight: 600;
}
.consent-actions {
  display: flex;
  gap: 0.6rem;
}
.consent-btn {
  flex: 1;
  padding: 0.7rem 1rem;
  border-radius: 9px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.08);
  color: white;
  font-family: var(--ff-body);
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--tr-fast);
}
.consent-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}
</style>
